import React, {Component} from 'react';
import {Container, Row, Col, Image} from 'react-bootstrap';
import './Projects.css';
import OsrwNav from './CustomNavbar';
import GibButtons from './GibButtons';
import Footer from './Footer';

export default class Projects extends Component {
    componentDidMount() {
        window.scrollTo(0, 0)
    }

    render() {
        let {appData} = this.props;
        let projects = appData.projects;
        let projectIdx = appData.selectedProjectIdx;
        const imgSrc = appData.isMobile ? projects[projectIdx].thumbnailSource : projects[projectIdx].imageSource;

        const rowStyle = {margin: imgSrc === null ? '18vh 7vw 3vh 7vw' : '3vh 7vw 3vh 7vw'};
        return (

            <Container style={{padding: 0, marginTop: '-1.2rem'}} fluid>
                <Image style={{width: '100%'}} src={imgSrc}/>
                <OsrwNav appData={appData} initColor="#0000001A"/>
                {appData.isMobile ?
                    (<Row style={rowStyle}>
                        <Col xs={16} sm={9}>
                            <h3>{projects[projectIdx].title}</h3>
                            <p>{projects[projectIdx].content}</p>
                        </Col>
                        <Col xs={16} sm={9}>
                            <GibButtons/>
                        </Col>
                    </Row>) :
                    (<Row style={rowStyle}>
                        <Col xs={16} sm={9} className="main-section">
                            <h3>{projects[projectIdx].title.toUpperCase()}</h3>
                            <p>{projects[projectIdx].content.toUpperCase()}</p>
                        </Col>
                        <Col xs={8} sm={3} className="sidebar-section">
                            <GibButtons/>
                        </Col>
                    </Row>)
                }
                <Footer/>
            </Container>
        )
    }
}
